import CustomHero from './custom-hero'

export default CustomHero
